import { api } from '../index';

export class StateService {
  static async getStates(params) {
    return api.get('admin/states', { params });
  }
}
